var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_269_36",
    "data-name": "Component 269 \\u2013 36",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25755",
    "data-name": "Group 25755"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3758",
    "data-name": "Rectangle 3758",
    width: 24,
    height: 24,
    rx: 2,
    fill: "rgba(0,0,0,0)",
    stroke: "#0074bd",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25756",
    "data-name": "Group 25756",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13625",
    "data-name": "Path 13625",
    d: "M1914.983,478.379v2h-12v-2a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v2a2.005,2.005,0,0,0,2,2h12a2.007,2.007,0,0,0,2-2v-2a1,1,0,0,0-1-1h0A1,1,0,0,0,1914.983,478.379Zm-1.706-5.7h0a1,1,0,0,0-1.41,0l-1.884,1.877v-7.172a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v7.172l-1.885-1.877a1,1,0,0,0-1.41,0h0a1,1,0,0,0,0,1.411l3.589,3.589a1,1,0,0,0,1.411,0l3.589-3.589A1,1,0,0,0,1913.277,472.674Z",
    transform: "translate(-1900.983 -466.379)",
    fill: "#0074bd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.2c39a756fe41216eb369d6cbc5cca6e8.svg";
export { ForwardRef as ReactComponent };